<template>
    <span :class="['status-label', 'service-fee-statement', statusName, size]">
        <span class="text">
            <span>{{ statusTxt }}</span>
            <span v-if="count !== null" class="count">{{ count }}</span>
        </span>
    </span>
</template>

<script>
import _ from 'lodash';
import { serviceFeeStatementStatus } from '@/assets/commonData/options';

export default {
    name: 'service-fee-statement-status-label',
    props: {
        statusNum: {
            type: Number,
            default: () => 0,
        },
        count: {
            type: Number,
            default: () => null,
        },
        size: {
            type: String,
            dafault: () => 'normal',
        },
        isTempSaved: {
            type: Boolean,
            dafault: () => false,
        },
        isPayInFuture: {
            type: Boolean,
            dafault: () => false,
        },
    },
    computed: {
        statusTxt() {
            return _.find(serviceFeeStatementStatus, ['key', this.statusNum])?.value;
        },
        statusName() {
            return _.find(serviceFeeStatementStatus, ['key', this.statusNum])?.name;
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.service-fee-statement.status-label {
    display: inline-block;
    height: 26px;
    line-height: 26px;
    padding: 0 10px;
    border-radius: 8px;
    background-color: #eee;

    > .text {
        font-size: 9.5pt;
        font-weight: 500;

        .count {
            opacity: 0.5;
            margin-left: 7px;
            font-weight: bold;
        }
    }

    &.wait-for-fill {
        background-color: #ffca79;
    }

    &.wait-for-confirm {
        background-color: #f6c6ff;
    }

    &.wait-for-pay {
        color: #fff;
        background-color: #463cb2;
    }

    &.paying {
        color: #1f3190;
        background-color: #dae0ff;
    }

    &.payed {
        color: #0baa1b;
        background-color: #def5d6;
    }

    &.signed {
        color: #0baa1b;
        background-color: #def5d6;
    }

    &.rejected {
        color: #ff2c2c;
        background-color: #ffe8e8;
    }
}
</style>
